export const COMMUNITY_LINKS = [
	{
		id: "discord",
		label: "Discord",
		href: "https://discord.gg/uu4m6TsYW",
	},
	{
		id: "tiktok",
		label: "TikTok",
		href: "https://www.tiktok.com/@muhaha.ai",
	},
	{
		id: "instagram",
		label: "Instagram",
		href: "https://www.instagram.com/hello.muhaha.ai/",
	},
] as const;

export type CommunityLinkId = (typeof COMMUNITY_LINKS)[number]["id"];
